import React, { useEffect, useState } from "react";
import ApiClient from "utils/ApiClient";
import Progress from "../Progress";
import ShareSheetUpdater from "./helpers/ShareSheetUpdater";

const ShareSheetTaskAction = ({ onRequestParams, onComplete, component }) => {
  const [emailAndRoles, setEmailAndRoles] = useState({emails:[],roles:[],edit:false})

  const [progress, setProgress] = useState({label: "Sharing sheet"})

  const cancelProcess = () => {
    onComplete(false, "Canceled by user.");
  };

  const shareSheetWithUpdatedParams = (params) => {
    setEmailAndRoles({ ...emailAndRoles, edit: false });
    let emails = params.emails;
    let role = params.role;
    shareSheet(true, { emails, role });
  };

  const shareSheet = async (modifyParams = false, modifiedParams = {}) => {
    let shareTheseEmails, shareToTheseRoles;
    let params = await onRequestParams();
    let sheetIds = params[0].sheetIds;

    if (modifyParams) {
      shareTheseEmails = modifiedParams.emails.split(",");
      shareToTheseRoles = [modifiedParams.role];
    } else {
      shareTheseEmails = params[0].emails;
      shareToTheseRoles = params[0].roles;
    }

    if (sheetIds.length == 0 || shareToTheseRoles.length == 0) {
      onComplete(false);
      return;
    }
    const roles = await window.appStore.assistantStore.getSheetRoles(sheetIds[0]);
    let group = roles.find((rl) => rl.name === `${shareToTheseRoles[0]}`);

    if (!group) {
      setEmailAndRoles({ emails: shareTheseEmails, roles: roles.map((el) => el.name), edit: true });
      return;
    }

    let groupUsers = "";

    try {
      let resp = await ApiClient.ListRoles.getRole({
        role_id: group.id,
      });
      group = resp.data;
    } catch (error) {
      onComplete(false);
      return;
    }
    groupUsers = group.hasOwnProperty("users") ? group.users : "";

    groupUsers = groupUsers.split(",");
    shareTheseEmails.forEach((el) => {
      if (!groupUsers.includes(el)) {
        groupUsers.push(el);
      }
    });

    let defaultPayload = {
      role_id: group.id,
      item_id: sheetIds[0],
      role: {
        users: groupUsers.join(","),
      },
    };

    try {
      if (group.id) {
        let response = await ApiClient.ListRoles.updateRole({
          role_id: group.id,
          item_id: sheetIds[0],
          role: defaultPayload.role,
        });
        if (response.success) {
          onComplete(true);
        } else {
          onComplete(false);
        }
      }
    } catch (error) {
      console.log(`ShareSheetTaskAction error catch->`, error);
      onComplete(false);
    }
  };

  useEffect(() => {
    shareSheet();
  }, []);

  if (emailAndRoles.edit) {
    return <ShareSheetUpdater emailAndRoles={emailAndRoles} shareSheet={shareSheetWithUpdatedParams} cancelProcess={cancelProcess} />;
  }

  return (
    <Progress progress={progress} parentComponent={component}/>
  );
};

export default ShareSheetTaskAction;
